<template>
  <main-container
    class="item-create-topbar"
    size="full"
    no-bottom-padding
  >
    <div class="item-create-topbar__navigation">
      <breadcrumb-listing-picker
        :title="entityName"
        :selected-id="entityId"
        :icon-name="TextAssistant.itemSingularName(entityType).toLowerCase()"
      />
      <template v-if="$screen.isTabletOrDesktop($mq)">
        <i :class="arrowClasses" />
        <div class="label">Create {{ TextAssistant.itemSingularName(entityType) }}</div>
      </template>
    </div>
  </main-container>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import MainContainer from '@/layouts/main-container.vue'

/* Mixins */

/* Components */

/* Helpers */
import BreadcrumbAssistant from '@/helpers/breadcrumb-assistant'
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'

/* API */

export default defineComponent({
  name: 'ItemCreateTopbar',

  components: {
    MainContainer,
  },

  props: {
    entityId: {
      type: Number,
      required: true,
    },
    entityName: {
      type: String,
      required: true,
    },
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
  },

  data() {
    return {
      EEntities,
      TextAssistant,
      BreadcrumbAssistant,
      scrolledPastTitle: false,
    }
  },

  computed: {
    arrowClasses(): string {
      if (this.$screen.isTabletOrDesktop(this.$mq)) {
        return 'ddi ddi-caret-right'
      }
      return 'hidden'
    },
  },

  mounted() {
    document.addEventListener('scroll', this.checkScrollPosition)
  },

  beforeUnmount() {
    document.removeEventListener('scroll', this.checkScrollPosition)
  },

  methods: {
    checkScrollPosition() {
      // Low-fi estimated height where the title is scrolled up.
      // Didn't want to get too sophisticated here.
      this.scrolledPastTitle = window.scrollY > 200
    },
  },
})
</script>

<style lang="scss">
.item-create-topbar {
  position: sticky;
  top: -2px;
  z-index: 1031;
  background-color: var(--color-background-primary);

  &__navigation {
    display: flex;
    align-items: center;
    padding-bottom: 18px;
    margin-bottom: 12px;
    border-bottom: $border--solid-light;
    width: 100%;

    > .ddi-caret-right {
      color: var(--color-text-primary);
      font-size: 8px;
      padding: 0 14px;
    }

    .label {
      @include single-line-ellipsis;
      color: var(--color-text-secondary);
    }

    @include media-breakpoint-down(sm) {
      flex-direction: column;
      justify-content: center;
      width: 100%;
      padding-right: $detail-gutter-pad-sm;
      padding-left: $detail-gutter-pad-sm;
      margin-bottom: 0;
    }
  }
}
</style>
